import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import ResourceUtils from 'lib/ResourceUtils';
import TzUtils from 'lib/TzUtils';
import React from 'react';

interface IProps {
    locale: string;
    label: string;
    required?: boolean;
    error?: boolean;
    disabled?: boolean;
    value?: string;
    helperText?: React.ReactNode;
    fullWidth?: boolean;
    onChange: (value: any) => void;
}

const MprcTimezoneSelectComponent: React.FC<IProps> = (props) => {

    const { locale, fullWidth, required, label, error, disabled, value, helperText, onChange } = props;

    return (
        <FormControl
            required={required}
            fullWidth={fullWidth}
            error={error}
        >
            <InputLabel id="timezoneLabel">{label}</InputLabel>
            <Select
                margin="dense"
                labelId="timezoneLabel"
                label={label}
                disabled={disabled}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                {
                    TzUtils.getAllTimezones()
                        .map((item) => ({ timezoneId: item.timezoneId, shortName: item.shortName, name: ResourceUtils.findName(item.nameR, locale, locale), offset: item.offset }))
                        .sort((a, b) => a.name!.localeCompare(b.name!))
                        .map((item, index) => (<MenuItem key={index} value={item.timezoneId}>{`${item.name} (${item.shortName})`}</MenuItem>))
                }
            </Select>
            <FormHelperText error={error}>
                {helperText}
            </FormHelperText>
        </FormControl>
    );
};

export const MprcTimezoneSelect = React.memo(MprcTimezoneSelectComponent, (prev, next) => {
    return prev.value == next.value
        && prev.helperText == next.helperText;
});